import { createFileRoute } from '@tanstack/react-router';
import SessionStatisticsPage from '@/features/user-sessions/session-statistics-page';

export const Route = createFileRoute('/_authenticated/user-sessions/statistics')({
  component: SessionStatisticsPage,
});
